// 引入Vue框架
import httpServe from '../utils/httpServe'
import userService from '../utils/user'
import global from '../utils/global'
import team from '../utils/team'

import recruitService from '../utils/recruit'
// 引入Vue框架
import Vue from 'vue'
import utils from "../utils/utils"
Vue.prototype.$global = global
Vue.prototype.$httpServe = httpServe
Vue.prototype.$userService = userService
Vue.prototype.$team = team
Vue.prototype.$recruitService = recruitService
Vue.prototype.$utils = utils
export default ({})



// WEBPACK FOOTER //
// ./src/http/index.js